import { Gender, TGender } from '@/core/models';
import dayjs from 'dayjs';
import { z } from 'zod';

const personalDetailsSchema = z.object({
   address_1: z.string().trim().min(1, 'Address 1 is required'),
   address_2: z.string(),
   post_code: z
      .string()
      .trim()
      .min(1, 'Post code is required')
      .max(10, 'Post code must be at most 10 characters')
      .regex(/^[a-zA-Z0-9 ]+$/, 'Invalid post code'),
   phone_number: z
      .string()
      .trim()
      .min(1, 'Phone number is required')
      .max(13, 'Phone number must be at most 13 characters'),
   date_of_birth: z
      .string()
      .trim()
      .min(1, 'Date of birth is required')
      .refine(val => {
         const dob = dayjs(val, ['YYYY-MM-DD'], true);
         if (!dob.isValid()) return false;
         const age = dayjs().diff(dob, 'year');
         return age >= 18;
      }, 'You must be at least 18 years old'),
   nationality: z.string().trim().min(1, 'Residence is required'),
   nhs_number: z.string().trim().min(1, 'NHS number is required').max(10, 'NHS number must be at most 10 characters'),
   state: z.string().trim().min(1, 'Town is required'),
   city: z.string().trim().min(1, 'City is required'),
   gender: z
      .string()
      .trim()
      .min(1, 'Gender is required')
      .refine(val => Object.values(Gender).includes(val as TGender), 'Invalid gender type'),
});

export type TPersonalDetails = z.infer<typeof personalDetailsSchema>;
export { personalDetailsSchema };
